import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class BreakdownService extends Service {
  path = 'avaria'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?avariaId=${params}`
    )
    return httpResponse
  }

  async active(params: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}/ativar?avariaId=${params}`
    )
    return httpResponse
  }

  async put(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?avariaId=${id}`,
      params
    )
    return httpResponse
  }
}

export const breakdownService = new BreakdownService()
